export * from './dropzone.directive';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/directives/dropzone/index.ts